import styled from '@emotion/styled'
import { Link } from '../../Links'

export const AboutCookiesLink = styled(Link)`
    margin-left: 4px;
`
